import _ from 'lodash';
import { getCourseData } from '@fiverr-private/fiverr_learn/src/utils/getCourseData';
import { getCompletedCourses } from '@fiverr-private/fiverr_learn/src/utils/getCompletedCourses';
import { degreeTitles } from './SellerProfile/EducationList/const';

export const biHelper = ({
    sellerId,
    buyerId,
    pageCtxId,
    position,
    count,
    group,
    data = []
}) => {
    const defaultImpression = {
        group,
        type: 'seller_page.show$viewport',
        seller: { id: sellerId },
        buyer: { id: buyerId },
        page: {
            ctx_id: pageCtxId,
            element: {
                position,
                visible: true
            }
        }
    };

    let learn_courses = '';
    if (group === 'seller_card_fiverr_learn_impression') {
        learn_courses = _.map(getCompletedCourses(data), ({ id }) =>
            _.get(getCourseData(id)[0], 'name'))
            .toString();
    }

    const impression = {
        seller_card_fiverr_pro_skills_verified_impression: {
            ...defaultImpression,
            seller: {
                ...defaultImpression.seller,
                card_skills: _.map(data, 'name').toString()
            }
        },
        seller_card_fiverr_learn_impression: {
            ...defaultImpression,
            seller: {
                ...defaultImpression.seller,
                learn_courses
            }
        },
        seller_card_about_me_component_impression: {
            ...defaultImpression,
            page: {
                ...defaultImpression.page,
                component: { name: 'seller_card_about_me_list' },
                element: {
                    ...defaultImpression.page.element,
                    name: 'seller_card_about_me_component'
                }
            }
        },
        seller_card_about_me_notable_projects_and_clients_impression: {
            ...defaultImpression,
            page: {
                ...defaultImpression.page,
                component: {
                    name: 'seller_card_about_me_notable_projects_and_clients'
                },
                element: {
                    ...defaultImpression.page.element,
                    type: 'text',
                    metadata: 'Notable projects and clients',
                    text: _.map(data, 'name').toString(),
                    name: 'seller_card_about_me_notable_projects_and_clients',
                    sub_element_count: count
                }
            }
        },
        seller_card_about_me_apperance_impression: {
            ...defaultImpression,
            page: {
                ...defaultImpression.page,
                component: { name: 'seller_card_about_me_apperance' },
                element: {
                    ...defaultImpression.page.element,
                    type: 'text',
                    metadata: 'Apperance',
                    text: _.map(data, 'institute_name').toString(),
                    name: 'seller_card_about_me_apperance'
                }
            }
        },
        seller_card_about_me_certifications_impression: {
            ...defaultImpression,
            page: {
                ...defaultImpression.page,
                component: { name: 'seller_card_about_me_certifications' },
                element: {
                    ...defaultImpression.page.element,
                    type: 'text',
                    metadata: 'Certifications',
                    text: _.map(data, 'certification_name').toString(),
                    name: 'seller_card_about_me_certifications'
                }
            }
        },
        seller_card_about_me_education_impression: {
            ...defaultImpression,
            page: {
                ...defaultImpression.page,
                component: { name: 'seller_card_about_me_education' },
                element: {
                    ...defaultImpression.page.element,
                    type: 'text',
                    metadata: 'Education',
                    text: _.map(data, (education) => `${degreeTitles[education.degree_title]} ${education.degree}`).toString(),
                    name: 'seller_card_about_me_education'
                }
            }
        },
        seller_card_about_me_social_presence_impression: {
            ...defaultImpression,
            page: {
                ...defaultImpression.page,
                component: { name: 'seller_card_about_me_social_presence' },
                element: {
                    ...defaultImpression.page.element,
                    type: 'text',
                    metadata: 'Social presence',
                    text: _.map(data, 'platform').toString(),
                    name: 'seller_card_about_me_social_presence'
                }
            }
        },
        seller_card_about_me_professional_presence_impression: {
            ...defaultImpression,
            page: {
                ...defaultImpression.page,
                component: {
                    name: 'seller_card_about_me_professional_presence'
                },
                element: {
                    ...defaultImpression.page.element,
                    type: 'text',
                    metadata: 'Professional presence',
                    text: _.map(data, 'platform').toString(),
                    name: 'seller_card_about_me_proffesional_presence'
                }
            }
        },
        seller_card_about_me_skills_impression: {
            ...defaultImpression,
            page: {
                ...defaultImpression.page,
                component: { name: 'seller_card_about_me_skills' },
                element: {
                    ...defaultImpression.page.element,
                    type: 'button',
                    metadata: 'Skills',
                    text: _.map(data, 'name').toString(),
                    name: 'seller_card_about_me_skills'
                }
            }
        },
        seller_card_about_me_linked_accounts_impression: {
            ...defaultImpression,
            page: {
                ...defaultImpression.page,
                component: { name: 'seller_card_about_me_linked_accounts' },
                element: {
                    ...defaultImpression.page.element,
                    type: 'button',
                    metadata: 'Linked accounts',
                    text: _.map(data, 'name').toString(),
                    name: 'seller_card_about_me_linked_accounts'
                }
            }
        },
        seller_card_about_me_languages_impression: {
            ...defaultImpression,
            page: {
                ...defaultImpression.page,
                component: { name: 'seller_card_about_me_languages' },
                element: {
                    ...defaultImpression.page.element,
                    type: 'text',
                    metadata: 'Languages',
                    text: data,
                    name: 'seller_card_about_me_languages'
                }
            }
        },
        seller_card_about_me_description_impression: {
            ...defaultImpression,
            page: {
                ...defaultImpression.page,
                component: { name: 'seller_card_about_me_description' },
                element: {
                    ...defaultImpression.page.element,
                    type: 'text',
                    metadata: 'Description',
                    name: 'seller_card_about_me_description',
                    sub_element_count: data.length
                }
            }
        }
    };

    return impression[group] || defaultImpression;
};
